import * as createRole from "@/api/roles/create";

export default {
	namespaced: true,
	state: {
		role: {},
		error: null,
	},
	getters: {
		readRole: (state) => state.role,
		readError: (state) => state.error,
	},
	mutations: {
		SET_ROLE(state, payload) {
			state.role = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async createRole({ commit, getters, rootGetters }) {
			let token = rootGetters["loginStore/readToken"];
			let createRoleRes = await createRole
				.createRole(token, getters.readRole)
				.then(() => {
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});
			return createRoleRes;
		},
	},
};
